const relationshipToClaimant = {
	Parent: {
		name: "Parent",
		value: "Parent"
	},
	Sibling: {
		name: "Sibling",
		value: "Sibling"
	},
	DeFactoPartner: {
		name: "De facto Partner",
		value: "De facto Partner"
	},
	HusbandOrWife: {
		name: "Husband / Wife",
		value: "Husband / Wife"
	},
	Relative: {
		name: "Relative",
		value: "Relative"
	},
	Guardian: {
		name: "Guardian",
		value: "Guardian"
	},
	LegalRepresentative: {
		name: "Legal Representative",
		value: "Legal Representative"
	},
	PowerOfAttorney: {
		name: "Power of Attorney",
		value: "Power of Attorney"
	},
	Trustee: {
		name: "Trustee",
		value: "Trustee"
	},
	Agent: {
		name: "Agent",
		value: "Agent"
	}
};

const relationshipToClaimantOptions = [
	{ name: relationshipToClaimant.Parent.name, value: relationshipToClaimant.Parent.value },
	{ name: relationshipToClaimant.Sibling.name, value: relationshipToClaimant.Sibling.value },
	{ name: relationshipToClaimant.DeFactoPartner.name, value: relationshipToClaimant.DeFactoPartner.value },
	{ name: relationshipToClaimant.HusbandOrWife.name, value: relationshipToClaimant.HusbandOrWife.value },
	{ name: relationshipToClaimant.Relative.name, value: relationshipToClaimant.Relative.value },
	{ name: relationshipToClaimant.Guardian.name, value: relationshipToClaimant.Guardian.value },
	{ name: relationshipToClaimant.LegalRepresentative.name, value: relationshipToClaimant.LegalRepresentative.value },
	{ name: relationshipToClaimant.PowerOfAttorney.name, value: relationshipToClaimant.PowerOfAttorney.value },
	{ name: relationshipToClaimant.Trustee.name, value: relationshipToClaimant.Trustee.value },
	{ name: relationshipToClaimant.Agent.name, value: relationshipToClaimant.Agent.value }
];

const contactRelationshipToClaimant = {
	relationshipToClaimant: relationshipToClaimant,
	options: relationshipToClaimantOptions
};

export default contactRelationshipToClaimant;
